import { RefObject, useCallback, useEffect, useState } from 'react';

import { useIsClient } from '@hooks/useIsClient';
import { scrollToPath } from '@utils/scrollTo';

type SectionRefs = RefObject<HTMLDivElement>[] | RefObject<HTMLDivElement>;

export const useSectionNavigation = (refs: SectionRefs) => {
  const [pathname, setPathname] = useState('');
  const isClient = useIsClient();

  useEffect(() => {
    if (isClient) {
      setPathname(window.location.pathname.replace('/', ''));
    }
  }, [isClient]);

  const onLinkClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      scrollToPath(event, refs);
    },
    [refs]
  );

  return { pathname, onLinkClick };
};
